import React from 'react';
import './BlackBackground.css';

const BlackBackground = () => {
  return <div className="black-background"></div>;
};

export default BlackBackground; 